module.exports = __webpack_public_path__ + "img/IM_dynamic_graphic.098187dc.svg";